import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { CompetitionBlacklistEffects } from './competition-blacklist.effects'
import * as fromCompetitionBlacklist from './competition-blacklist.reducer'
import { CompetitionBlacklistSerializer } from './competition-blacklist.serializer'
import { CompetitionBlacklistService } from './competition-blacklist.service'
import { BlackListCardComponent } from './blacklist-card/blacklist-card.component'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(
      fromCompetitionBlacklist.FEATURE_NAME,
      fromCompetitionBlacklist.competitionBlacklistReducer
    ),
    EffectsModule.forFeature([CompetitionBlacklistEffects])
  ],
  providers: [
    CompetitionBlacklistService,
    {
      provide: CompetitionBlacklistSerializer,
      useClass: CompetitionBlacklistSerializer
    }
  ],
  declarations: [BlackListCardComponent],
  exports: [BlackListCardComponent]
})
export class CompetitionBlacklistModule {}
